import { useState } from 'react';
import z from 'zod';

import { AkaThemaId, ThemaFromThemaRouter } from '../../../dtos';
import { getPendantLabel, isOnlineAndOrPraesenz } from '../../../utils/isOnline';

export const useOnlinePraesenzFilter = (thema: ThemaFromThemaRouter) => {
  const [selectedOptions, setSelectedOptions] = useState([thema.akaThemaId]);
  const isFullyOnline = isOnlineAndOrPraesenz(thema.isOnline, thema.planungsformat, thema.module) === 'ONLINE';

  const allOptions = [
    {
      label: isFullyOnline ? 'Online' : 'Präsenz',
      value: thema.akaThemaId,
    },
  ];
  if (thema.verknuepfteThemen.length === 1) {
    const [pendant] = thema.verknuepfteThemen;
    allOptions.push({ label: getPendantLabel(pendant), value: pendant.akaThemaId });
  }

  const toggleOption = (clickedOption: string) => {
    // @todo AKAVM-2867 - Zod-Schema loswerden
    const clickedAkaThemaId = z.templateLiteral(['T', z.number().min(10000).max(99999)]).parse(clickedOption);
    setSelectedOptions((prev: AkaThemaId[]) =>
      prev.includes(clickedAkaThemaId)
        ? prev.filter((option) => option !== clickedAkaThemaId)
        : [...prev, clickedAkaThemaId],
    );
  };

  return { allOptions, selectedOptions, toggleOption };
};
